import { Box, Button, Flex, Input, Text, VStack } from '@chakra-ui/react'
import { FC, KeyboardEvent } from 'react'

interface Props {
  codigo: string
  setCodigo: (v: string) => void
  loading: boolean
  error: string | null
  onSubmit: () => void
}

const TelaVerificacao: FC<Props> = ({
  codigo,
  setCodigo,
  loading,
  error,
  onSubmit
}) => {
  const handleKey = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && codigo.trim()) onSubmit()
  }

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      minH="calc(100vh - 64px)"
      bg="#f8fafc"
      px={4}
    >
      <Box
        bg="white"
        borderRadius="2xl"
        p={8}
        w="100%"
        maxW="380px"
        boxShadow="0 4px 24px rgba(0,0,0,0.08)"
        border="1px solid"
        borderColor="gray.100"
      >
        <VStack spacing={5} align="stretch">
          <Box textAlign="center">
            <Text fontSize="22px" fontWeight="800" color="gray.900" mb={1}>
              Verificação de Acesso
            </Text>
            <Text fontSize="14px" color="gray.500" lineHeight="1.6">
              Informe o código de acesso enviado junto ao e-mail de convite.
            </Text>
          </Box>

          <Box>
            <Text fontSize="12px" fontWeight="600" color="gray.600" mb={1}>
              CÓDIGO DE ACESSO
            </Text>
            <Input
              placeholder="Digite o código..."
              value={codigo}
              onChange={e => setCodigo(e.target.value)}
              onKeyDown={handleKey}
              size="lg"
              borderColor={error ? 'red.400' : 'gray.300'}
              borderRadius="lg"
              fontSize="18px"
              letterSpacing="3px"
              textAlign="center"
              fontWeight="700"
              textTransform="uppercase"
              _focus={{
                borderColor: error ? 'red.400' : '#0f5238',
                boxShadow: error ? '0 0 0 1px #fc8181' : '0 0 0 1px #0f5238'
              }}
              autoFocus
            />
            {error && (
              <Text fontSize="12px" color="red.500" mt={1} fontWeight="500">
                {error}
              </Text>
            )}
          </Box>

          <Button
            size="lg"
            bg="#0f5238"
            color="white"
            borderRadius="lg"
            fontWeight="700"
            isLoading={loading}
            loadingText="Verificando..."
            isDisabled={!codigo.trim()}
            onClick={onSubmit}
            _hover={{ bg: '#1d5840' }}
            _active={{ bg: '#0a3d29' }}
          >
            Acessar
          </Button>
        </VStack>
      </Box>
    </Flex>
  )
}

export default TelaVerificacao
